import { createFileRoute } from "@tanstack/react-router";
import { CategoryPage } from "@/components/CategoryPage";
import { getAllPosts } from "@/lib/posts.functions";
import { listApprovedThemes } from "@/lib/themes-public.functions";
import { useLocalizedPosts } from "@/lib/wp.hooks";
import { useT } from "@/lib/i18n";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/iklim-sistemleri")({
  head: () => ({
    meta: [
      { title: pageTitle("İklim & Sistemler", "tr") },
      { name: "description", content: "İklim, enerji ve biyosferi ayakta tutan sistemler üzerine denemeler: karbon bütçesi, enerji dönüşümü, veri merkezleri ve iklim politikasının sınırları." },
      { property: "og:title", content: "İklim & Sistemler — Akıllı Sürdürülebilirlik" },
      { property: "og:description", content: "İklim ve gezegen sistemleri üzerine denemeler." },
      { property: "og:url", content: "https://akillisurdurulebilirlik.com/iklim-sistemleri" },
      { property: "og:locale", content: "tr_TR" },
      { property: "og:locale:alternate", content: "en_US" },
    ],
    links: [
      { rel: "canonical", href: "https://akillisurdurulebilirlik.com/iklim-sistemleri" },
      ...hreflangLinks("/iklim-sistemleri", "/climate-systems"),
    ],
  }),
  loader: async () => {
    const [posts, themes] = await Promise.all([getAllPosts(), listApprovedThemes()]);
    return { posts, themes };
  },
  component: Page,
});

function Page() {
  const { t } = useT();
  const data = Route.useLoaderData();
  const { articles: posts } = useLocalizedPosts(data.posts);
  return (
    <CategoryPage
      themes={data.themes}
      category={t("cat.climate.title")}
      tagline={t("cat.climate.tagline")}
      essays={posts.filter((p) => String(p.category) === "Climate & Systems" || String(p.category) === "İklim & Sistemler")}
    />
  );
}
